import type { RealestateAsset } from "~/types/assets.types";
import { calculateOwnership } from "../genericCalculations/ownership";

export const calculateRealestatePurchaseExpenses = (
  userProduct: RealestateAsset
) => {
  const purchasePrice = userProduct?.purchasePrice || 0;
  const purchaseExpenses = userProduct?.purchaseExpenses || 0;
  const ownership = userProduct?.ownership || 0;

  const totalPurchaseExpenses =
    Number(purchasePrice) + Number(purchaseExpenses);

  return calculateOwnership(totalPurchaseExpenses, ownership);
};
